import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { ReportingCycleEditor } from '@/internal-app/pages/reportingCycles'
import { Frequency } from '@/enums/Frequency'
import ErrorBoundary from '@/components/ErrorBoundary'

class NewReportingCycleDialog extends React.Component {
  state = {
    value: {
      id: 0,
      name: this.props.localize('Reporting.NewReportingCycle'),
      latinName: this.props.localize('Reporting.NewReportingCycle'),
      frequency: Frequency.WEEKLY,
      snapshotDateValue: null,
      snapshotIntValue: 0,
      snapshotOffset: '0',
      dueDateValue: null,
      dueIntValue: 0,
      dueOffset: '0',
      extendedGraceDueDate: 5,
      year: this.props.year
    }
  }
  render () {
    const props = this.props
    return (
      <React.Fragment>
        <BasicHeader title='Reporting.ReportingCycle' {...props} />
        <ModalBody>
          <ErrorBoundary>
            <ReportingCycleEditor
              localize={props.localize}
              year={props.year}
              reportingCycle={this.state.value}
              onChange={value => this.setState({ value })} />
          </ErrorBoundary>
        </ModalBody>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => this.props.onAction(this.state.value)} />
      </React.Fragment>
    )
  }
}

export default {
  component: NewReportingCycleDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/newReportingCycle.js